import { render, staticRenderFns } from "./videoContent.vue?vue&type=template&id=b59f0ac2&scoped=true&"
import script from "./videoContent.vue?vue&type=script&lang=js&"
export * from "./videoContent.vue?vue&type=script&lang=js&"
import style0 from "./videoContent.vue?vue&type=style&index=0&id=b59f0ac2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59f0ac2",
  null
  
)

export default component.exports